export default {
  authFail: '获取oauthCode失败',
  alipayParamsFail: '支付宝版本过低或者当前启动appid错误',
  versionFail: '当前版本不支持获取oauthCodeApi',
  envFail: '当前环境不支持获取oauthCodeApi'
}
